import { ApiProperty } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { BumpResourceSheetPaidBatchResultInterface } from '../interfaces/bump-resource-sheet-paid-batch-result.interface';

@Exclude()
export class BumpResourceSheetPaidBatchResultDto
  implements BumpResourceSheetPaidBatchResultInterface
{
  @ApiProperty({
    type: 'number',
    title: 'Marked count',
    description:
      'Rows of both types that received a new "Paid" history entry in this run.',
  })
  @Expose()
  markedCount!: number;

  @ApiProperty({
    type: 'number',
    title: 'Skipped count',
    description:
      'Rows of both types that were already paid and were left untouched.',
  })
  @Expose()
  skippedCount!: number;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    isArray: true,
    title: 'Marked Job Phase Bump IDs',
  })
  @Expose()
  markedJobPhaseBumpIds!: string[];

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    isArray: true,
    title: 'Skipped Job Phase Bump IDs',
  })
  @Expose()
  skippedJobPhaseBumpIds!: string[];

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    isArray: true,
    title: 'Marked Repair Payment IDs',
  })
  @Expose()
  markedRepairPaymentIds!: string[];

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    isArray: true,
    title: 'Skipped Repair Payment IDs',
  })
  @Expose()
  skippedRepairPaymentIds!: string[];
}
